<span class="{{ iconStatus }}">
  <svg-icon [src]="teslaIconSrc" [applyClass]="true" [svgStyle]="{ 'height.px': height, 'width.px': width, 'margin-left.px': marginLeft, 'margin-right.px': marginRight, 'margin-top.px': marginTop }" class="tesla-icon"></svg-icon>
</span>
